import { useSelector } from "react-redux";
import PlayerFormat from "../../util/player-format";
import { useTennisTeamContext } from "../team-context/tennis-context";

const usePlayersTennisContext = (team) => {
	const { state: teamStatsState } = useTennisTeamContext({ team });

	const useSinglePlayers = () => {
		const single = teamStatsState.single() || [];

		return useSelector((state) =>
			state.players.players
				.filter((p) => p.teamId === team.id)
				.filter((p) => single.includes(p.id))
		);
	};

	const useDoublesPlayers = () => {
		const doubles = teamStatsState.doubles() || [];

		return useSelector((state) =>
			state.players.players
				.filter((p) => p.teamId === team.id)
				.filter((p) => doubles.includes(p.id))
		);
	};

	const useNAPlayers = () => {
		return useSelector((state) =>
			state.players.players.filter(
				(p) =>
					p.teamId === team.id && p.uniform === PlayerFormat.NotSpecifiedUniform
			)
		);
	};

	const state = {
		single: useSinglePlayers,
		doubles: useDoublesPlayers,
		naPlayers: useNAPlayers
	};

	return {
		state
	};
};

export { usePlayersTennisContext };
